import { FileInput, SelectInput } from "@validereinc/common-components";
import { find } from "es-toolkit/compat";
import * as PropTypes from "prop-types";
import React from "react";

const ThirdPartyLabImportForm = ({ formState, sites }) => {
  const sharedProps = {
    isDisabled: formState !== "enabled",
    isRequired: true,
  };

  return (
    <>
      {/* @ts-expect-error legacy opshub typing */}
      <SelectInput
        {...sharedProps}
        name="site"
        label="Site"
        labelKey="name"
        options={sites}
        ignoreCase
      />

      <FileInput
        {...sharedProps}
        name="attachment"
        label="Attachment"
        allowMultiple={false}
        rules={{
          validate: (files) => {
            const twentyMB = 1 * 1000 * 1000;
            const fileOverSizeLimit = find(
              files,
              (file) => file.size > twentyMB
            );
            return fileOverSizeLimit ? "File size is too large." : undefined;
          },
        }}
      />
    </>
  );
};

ThirdPartyLabImportForm.propTypes = {
  formState: PropTypes.string,
  sites: PropTypes.array.isRequired,
};

export default ThirdPartyLabImportForm;
